module.exports = __webpack_public_path__ + "img/financialperformance-436x218-pdfdownload.6c3c4d03.jpg";